__turbopack_context__.v({
  "accessBadge": "Members-module__R3JRra__accessBadge",
  "container": "Members-module__R3JRra__container",
  "count": "Members-module__R3JRra__count",
  "deleteAction": "Members-module__R3JRra__deleteAction",
  "editAction": "Members-module__R3JRra__editAction",
  "empty": "Members-module__R3JRra__empty",
  "header": "Members-module__R3JRra__header",
  "inviteActions": "Members-module__R3JRra__inviteActions",
  "list": "Members-module__R3JRra__list",
  "loaderWrapper": "Members-module__R3JRra__loaderWrapper",
  "pendingBadge": "Members-module__R3JRra__pendingBadge",
  "roleBadge": "Members-module__R3JRra__roleBadge",
  "row": "Members-module__R3JRra__row",
  "rowActions": "Members-module__R3JRra__rowActions",
  "rowEmail": "Members-module__R3JRra__rowEmail",
  "rowEnd": "Members-module__R3JRra__rowEnd",
  "rowInfo": "Members-module__R3JRra__rowInfo",
  "rowName": "Members-module__R3JRra__rowName",
  "sectionTitle": "Members-module__R3JRra__sectionTitle",
});
